import { render, staticRenderFns } from "./PricesView.vue?vue&type=template&id=61526531&"
import script from "./PricesView.vue?vue&type=script&lang=js&"
export * from "./PricesView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports